/**
 * Badge - Status and category indicators
 */

import { cn } from '@/lib/infra/utils';

type BadgeVariant = 'default' | 'success' | 'warning' | 'danger' | 'info' | 'yes' | 'no';

interface BadgeProps {
  children: React.ReactNode;
  variant?: BadgeVariant;
  size?: 'xs' | 'sm' | 'md';
  className?: string;
}

const variantClasses: Record<BadgeVariant, string> = {
  default: 'bg-muted text-muted-foreground',
  success: 'bg-green-500/20 text-green-500',
  warning: 'bg-yellow-500/20 text-yellow-500',
  danger: 'bg-red-500/20 text-red-500',
  info: 'bg-blue-500/20 text-blue-500',
  yes: 'bg-emerald-500/20 text-emerald-400 border border-emerald-500/30',
  no: 'bg-rose-500/20 text-rose-400 border border-rose-500/30',
};

const sizeClasses = {
  xs: 'text-[10px] px-1.5 py-0.5',
  sm: 'text-xs px-2 py-0.5',
  md: 'text-sm px-2.5 py-1',
};

export function Badge({ children, variant = 'default', size = 'sm', className }: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-md font-medium',
        variantClasses[variant],
        sizeClasses[size],
        className
      )}
    >
      {children}
    </span>
  );
}

export default Badge;
